
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/addPreset/addSection/components/addSectionCategoryHeader.scss.css.virtualfile';
        module.exports = {"addSectionCategoryHeader":"_addSectionCategoryHeader_1x7sf_7"};